module.exports = __webpack_public_path__ + "static/media/euro-sign.409eee7e.svg";